<template>
  <document-request-tab>
    <template v-slot:title class="pl-5 booking-list-title"
      >{{ $route.name }}
    </template>
    <template v-slot:content>
      <div>
        <v-btn v-if="checkPerUser" class="t-btn--prm my-3" @click="visible = 2">
          選択項目に担当者割振
        </v-btn>
      </div>
      <v-card>
        <Table
          :filter="filter"
          ref="table"
          :itemsPerPage="10"
          :itemsPerPageOptions="[10, 20, 50, 100, 200, 500]"
          :attr="{
            dense: true,
            'no-data-text': $t('rules.noData'),
            'item-key': 'id',
          }"
          :headers="headers"
          :total="total"
          :funReset="getWebRequestlistDocumentRequestlists"
          :items="webRequestlistDocumentRequestlistFalse"
          :sortField="[]"
          :showSelect="true"
          :multiSort="true"
          @setSelected="
            value => {
              selected = value;
            }
          "
        >
          <template v-slot:[`item.mediasType`]="{ item }">
            <span>{{
              item.medias && item.medias.map(c => c.mediaType).join(', ')
            }}</span>
          </template>
          <template v-slot:[`item.picName`]="{ item }">
            <div v-if="item.client">
              <div v-if="item.client.pic">
                {{ item.client.pic.name }}
              </div>
              <div v-else>
                <span class="textCustomerSalesRepresentative">未割振</span>
              </div>
            </div>
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ item.createdAt.substr(5, 2) }}/{{ item.createdAt.substr(8, 2) }}
          </template>
          <template v-slot:[`item.isCompany`]="{ item }">
            <div v-if="item.client">
              {{ item.client.isCompany ? '法人' : '個人' }}
            </div>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <div v-if="item.client">
              {{ item.client.name }}
            </div>
          </template>
          <template v-slot:[`item.forVmAndforVs`]="{ item }">
            <span v-if="item.forVm">VM</span>
            <span v-if="item.forVs">,&nbsp;VS</span>
          </template>
          <template v-slot:[`item.importMethod`]="{ item }">
            {{ item.importMethod.toUpperCase() }}
          </template>
          <template v-slot:[`item.user`]="{ item }">
            <v-btn
              class="t-btn--prm"
              icon
              target="_blank"
              :to="
                '/customer-details/' +
                  item.client.id +
                  '?typeClient=' +
                  item.client.type
              "
              @click="idDoc = item.id"
            >
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-btn
              :disabled="!checkPerUser"
              class="btn-crm-primary"
              style="border: 0px"
              @click="handleClickEdit(item)"
              icon
            >
              <v-icon x-large>mdi-pencil-circle</v-icon>
            </v-btn>
          </template>
        </Table>
      </v-card>
      <!-- Dialog -->
      <documentRequestDetailCorporation
        v-if="checkPerUser"
        :visible="visible === 0"
        :dataUrl="data"
        @close="visible = -1"
        @reloadList="reloadList"
      ></documentRequestDetailCorporation>
      <documentRequestDetailIndividual
        v-if="checkPerUser"
        :visible="visible === 1"
        :dataUrl="data"
        @close="visible = -1"
        @reloadList="reloadList"
      ></documentRequestDetailIndividual>
      <SalesRepresentativeAllocation
        v-if="checkPerUser"
        :visible="visible === 2"
        @close="visible = -1"
        :webRequestListDocumentRequestListSelected="selected"
      />
    </template>
  </document-request-tab>
</template>

<script>
import documentRequestTab from '../documentRequestTab.vue';
import documentRequestDetailIndividual from './documentRequestDetailIndividual.vue';
import documentRequestDetailCorporation from './documentRequestDetailCorporation.vue';
import SalesRepresentativeAllocation from './SalesRepresentativeAllocation';
import { checkPermissionUserCurrent } from '@/utils/permissions';
import { mapActions, mapMutations } from 'vuex';
import { WEB_REQUESTLIST_DOCUMENT_REQUESTLIST } from '@/api/graphql/dashboard/webPageManage/documentrequest/DuplicateExistingCustomers/index.js';
import gql from 'graphql-tag';
import Table from '@/components/Table/index.vue';

export default {
  name: 'BookingList',
  components: {
    documentRequestTab,
    documentRequestDetailIndividual,
    documentRequestDetailCorporation,
    SalesRepresentativeAllocation,
    Table,
  },
  data() {
    return {
      total: null,
      webRequestlistDocumentRequestlistFalse: null,
      filter: {
        hasPic: false,
        forVm: true,
      },
      data: {},
      checkPerUser: checkPermissionUserCurrent(this.$router.currentRoute),
      selected: [],
      idDoc: '',
      visible: -1,
      // Table
      headers: [
        {
          text: '反響媒体', // text1
          value: 'mediasType',
          fieldName: 'media.mediaType',
          algin: 'center',
        },
        {
          text: '顧客営業担当', // text2
          sortable: false,
          value: 'picName',
          algin: 'center',
        },
        {
          text: '受信日', // text3
          value: 'createdAt',
          algin: 'center',
          fieldName: 'webRequest.createdAt',
        },

        {
          text: '顧客詳細', // text4
          sortable: false,
          value: 'user',
          algin: 'center',
        },

        {
          text: '法人/個人', // text5
          value: 'isCompany',
          algin: 'center',
          fieldName: 'client.isCompany',
        },
        {
          text: '名前/会社名', // text5
          sortable: false,
          value: 'name',
          algin: 'center',
        },
        {
          text: '請求資料', // text6
          value: 'forVmAndforVs',
          algin: 'center',
          fieldName: 'webRequest.forVs',
        },
        {
          text: '取り込み方法', // text7
          algin: 'center',
          value: 'importMethod',
          fieldName: 'webRequest.importMethod'
        },
        {
          text: '詳細', // text8
          sortable: false,
          value: 'edit',
          algin: 'center',
        },
      ],
    };
  },

  mounted() {
    this.$refs.table.reset();
  },
  methods: {
    ...mapActions([
      'getWebRequestlistDocumentRequestlist',
      'getWebrequestNotIscopanyDocumentRequestList',
    ]),
    ...mapMutations(['setWebRequestlistDocumentRequestListFalse', 'setTotal']),

    async getWebRequestlistDocumentRequestlists(variables) {
      await this.$apollo
        .query({
          query: gql`
            ${WEB_REQUESTLIST_DOCUMENT_REQUESTLIST}
          `,
          variables: variables,
          fetchPolicy: 'no-cache',
        })
        .then(data => {
          this.webRequestlistDocumentRequestlistFalse =
            data.data.webRequestList.items;
          this.total = data.data.webRequestList.total;
          this.setTotal(this.total);
        })
        .catch(error => {
          console.error(error);
        });
    },

    reloadList(value, id) {
      const newArr = this.webRequestlistDocumentRequestlistFalse;
      const objIndex = newArr.findIndex(e => e.id === id);
      newArr[objIndex].client.pic.id = value.client.pic.id;
      newArr[objIndex].client.pic.name = value.client.pic.name;
      this.setWebRequestlistDocumentRequestListFalse(newArr);
    },

    async handleClickEdit(item) {
      await this.getWebrequestNotIscopanyDocumentRequestList(item.id).then(
        async result => {
          this.data = {
            id: item.id,
            idClient: item.client.id,
            typeClient: item.client.type,
            nameClient: item.client.name,
          };
          if (item.client.isCompany === true) {
            this.visible = 0;
          } else {
            this.visible = 1;
          }
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table-header {
    tr {
      th {
        color: #757575 !important;
        font-size: 14px !important;
        font-weight: bold !important;
      }
    }
  }
  .v-data-table-header__icon {
    .v-icon__svg {
      color: #000000 !important;
    }
  }
  .v-data-footer__select {
    color: #000000 !important;
    font-size: 13px !important;
    font-weight: 500;
    .v-select__selection--comma {
      color: #000000 !important;
      font-size: 13px !important;
      font-weight: 500;
    }
  }
  .v-input__append-inner {
    .v-icon__svg {
      color: #333333 !important;
    }
  }
  .v-data-footer__pagination {
    display: none !important;
  }
  tbody {
    tr {
      height: auto !important;
      td {
        padding: 0 16px;
        font-size: 14px !important;
        color: #757575 !important;
        .v-btn--icon.v-size--default {
          height: 32px;
          width: 32px;
          margin: 2px;
        }
      }
    }
  }
}
.v-data-table::v-deep {
  th {
    color: #000 !important;
  }
  .v-data-footer,
  .v-select__selection {
    font-size: 14px !important;
  }
  tbody > tr > td {
    align-items: center !important;
  }
}
.message {
  margin-left: 5px;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 6px;
  background-color: red;
  color: white;
}
.textCustomerSalesRepresentative {
  font-weight: bold;
  color: #c92d2d;
}
</style>
